
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import CardInformationContainer from "../../../Components/Cards/Information/container";
import MobileCarousel from "../../../Components/Cards/Information/MobileCarousel";
import { API_BASE_URL } from "../../../config/api";

export default function CardContainer() {
  const navigate = useNavigate();
  const [accLoading, setAccLoading] = useState(true);
  const [statsData, setStatsData] = useState(null);

  const fetchStatsData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}dashboard/stats/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}dashboard/stats/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setStatsData(data);
      setAccLoading(false);
    } catch (error) {
      setAccLoading(false);
      console.error("Error fetching account data:", error);
    }
  };
  useEffect(() => {
    fetchStatsData();
  }, []);
  return (
    <div className="w-full h-fit bg-zi-bg2-light dark:bg-zi-bg2-dark rounded-2xl p-5">
      <MobileCarousel>
        <CardInformationContainer
          color="blue"
          width="300px"
          title="تعداد حساب‌های فعال"
          value={statsData?.active_accounts || 0}
          link={true}
          data=""
          button={true}
          buttonText="خرید چالش جدید"
          svgName="challenge"
          svgClassName="stroke-white"
          accLoading={accLoading}
          hrefButton={"/purchase"}
          hrefLink={"/Challenge"}
        />
        <CardInformationContainer
          color="green"
          width="300px"
          title="مجموع سود حساب‌های فاندد"
          value={
            statsData?.funded_profit
              ? Number(statsData?.funded_profit) >= 0
                ? `$${statsData?.funded_profit}`
                : `-$${Number(statsData?.funded_profit) * -1}`
              : "$0"
          }
          link={true}
          data=""
          button={true}
          valueLtr={true}
          buttonText="برداشت سود"
          svgName="profitAvailable"
          svgClassName=""
          accLoading={accLoading}
          hrefButton={"/Transaction/Withdraw"}
          hrefLink={"/Transaction/Withdraw"}
        />
        <CardInformationContainer
          color="yellow"
          width="300px"
          title="سود حاصل از دعوت دوستان"
          value={
            statsData?.referral_profit
              ? Number(statsData?.referral_profit) >= 0
                ? `$${statsData?.referral_profit}`
                : `-$${Number(statsData?.referral_profit) * -1}`
              : "$0"
          }
          valueLtr={true}
          link={true}
          data=""
          button={true}
          buttonText="دعوت از دوستان"
          svgName="friend"
          svgClassName=""
          accLoading={accLoading}
          hrefButton={"/invite"}
          hrefLink={"/invite/gift"}
        />
      </MobileCarousel>
    </div>
  );
}
